import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import GroupIcon from "@mui/icons-material/GroupOutlined";
import { IconButton, Stack, Typography } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid-premium";
import { useMemo } from "react";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import type { ClientUserGroupInfo } from "../../../../api/types/userManagementTypes";

const getColumnDefinitions = (
  onDeleteUserGroup: (row: ClientUserGroupInfo) => void
): GridColDef<ClientUserGroupInfo>[] => [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    minWidth: 160,
    renderCell: ({ row }) => (
      <GridTextHoverLink to={row.id}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center", minWidth: 0 }}>
          <GroupIcon color="action" />
          <Typography noWrap>{row.name}</Typography>
        </Stack>
      </GridTextHoverLink>
    ),
  },
  {
    field: "countOfMembers",
    headerName: "Members",
    type: "number",
    flex: 0.5,
    minWidth: 120,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 72,
    cellClassName: "grid-row-actions",
    align: "right",
    headerAlign: "right",
    renderCell: ({ row }) => (
      <IconButton color="error" onClick={() => onDeleteUserGroup(row)}>
        <DeleteIcon />
      </IconButton>
    ),
  },
];

interface Props {
  rows: ClientUserGroupInfo[];
  loading?: boolean;
  onDeleteUserGroup: (row: ClientUserGroupInfo) => void;
}

const UserGroupsGrid = ({ rows, loading, onDeleteUserGroup }: Props) => {
  const columns = useMemo(() => getColumnDefinitions(onDeleteUserGroup), [onDeleteUserGroup]);

  return (
    <DataGrid<ClientUserGroupInfo>
      rows={rows}
      columns={columns}
      loading={loading}
      noRowsText="No user groups"
      disableColumnSorting
      disableColumnReorder
      disableColumnPinning
      disableMultipleRowSelection
    />
  );
};

export default UserGroupsGrid;
